/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';
import {
  halfSpacing,
  largeSpacing,
  quarterSpacing,
  tripleSpacing,
} from 'styles/global_defaults/scaffolding';
import {
  black,
  gray2,
  gray4,
  gray5,
  primary,
  white,
} from 'styles/global_defaults/colors';
import { isRtl } from 'styles/global_defaults/media-queries';
import { ScaleLimits } from './types';

type StyleProps = {
  value: number;
  limits: ScaleLimits;
  isDisabled: boolean;
  factor: number;
  showHandleColor?: boolean;
  handleColor?: string;
};

export const getStyles = ({
  value,
  isDisabled,
  limits,
  factor,
  showHandleColor = false,
  handleColor = primary,
}: StyleProps) => css`
  .answer-slider {
    .slide {
      margin-top: ${tripleSpacing}px;
      .rc-slider-track {
        background-color: transparent;
      }
      .rc-slider-step {
        background-color: ${isDisabled ? gray5 : gray4};
      }
      .rc-slider-disabled {
        background-color: transparent;
      }
      .rc-slider-handle-dragging,.rc-slider-handle: hover {
        ${!isDisabled
        && css`
          background-color: ${white} !important;
          border-color: ${primary} !important;
          border-width: 4px;
          width: 24px !important;
          height: 24px !important;
          margin-top: -${halfSpacing}px !important;
          box-shadow: 0 0 0 7px ${primary}33; // 33 with primary represent 0.2 opacity
          opacity: 1;
        `}
      }
      .rc-slider-handle {
        ${(isDisabled)
        && css`
          display: none;
        `}
        background-color: ${white};
        border-color: ${isDisabled ? gray5 : gray4};
        border-width: 4px;
        width: 24px;
        height: 24px;
        margin-top: -${halfSpacing}px;
        opacity: 1;

        ${!isDisabled
        && showHandleColor
        && css`
          background-color: ${handleColor};
          border-color: ${white};
          border-width: 4px;
          width: 28px;
          height: 28px;
          margin-top: -12px;
        `}
      }
      // Do not show dot mark for the left limit and right limit when they are not factors.
      .rc-slider-dot:first-child {
        ${limits?.min.value % factor !== 0
        && css`
          display: none;
        `}
      }
      .rc-slider-dot:last-child {
        ${limits?.max.value % factor !== 0
        && css`
          display: none;
        `}
      }
      .rc-slider-dot {
        position: absolute;
        border: 4px solid white;
        background-color: ${isDisabled ? gray5 : gray4};
        width: 18px;
        height: 18px;
        top: calc(50% - 9px);
      }
      .rc-slider-mark-text {
        top: -${tripleSpacing}px;
        font-size: 18px;
        font-weight: 700;
        color: ${black};
      }
    }
  }
  .slider-container {
    position: relative;
    width: 100%;
    margin-top: 130px;
    .left-limit {
      position: absolute;
      // handling RTL switching, By default, CSS transform: translate(x, y) does not respect the direction of the document (LTR/RTL)
      transform: translate(
        calc(${isRtl() ? '50% - 30px' : '-50% + 30px'}),
        calc(-100% - 20px)
      );
    }
    .right-limit {
      position: absolute;
      left: 100%;
      // handling RTL switching, By default, CSS transform: translate(x, y) does not respect the direction of the document (LTR/RTL)
      transform: translate(
        calc(${isRtl() ? '50% + 30px' : '-50% - 30px'}),
        calc(-100% - 20px)
      );
    }
    .slide {
      padding-left: ${largeSpacing}px;
      padding-right: ${largeSpacing}px;
      .rc-slider-mark-text {
        display: none;
      }
      .rc-slider-rail {
        background-color: ${gray4};
      }
      .rc-slider-track {
        background-color: ${primary};
      }
      .rc-slider-dot-active {
        background-color: ${primary} !important;
        border: 4px solid white !important;
      }
      .rc-slider-dot {
        position: absolute;
        border: 4px solid white;
        background-color: ${gray4};
        width: 18px;
        height: 18px;
        top: calc(50% - 9px);

        // left-limit slider dot color should be primary on left limit input is focused
        :first-child {
          background-color: ${limits?.min.isInputFocused ? primary : gray4};
        }
        // right-limit slider dot color should be primary on right limit input is focused
        :last-child {
          background-color: ${limits?.max.isInputFocused ? primary : gray4};
        }
      }
      .rc-slider-handle {
        background-color: ${primary} !important;
        border: 4px solid white !important;
        opacity: 1;
        width: 18px;
        height: 18px;
        top: 3px;
      }
      .rc-slider-handle-1::after,
      .rc-slider-handle-2::after {
        content: attr(data-content);
        position: absolute;
        font-size: 18px;
        font-weight: 700;
        top: -25px;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
    }
  }
  .label-section {
    margin-top: 25px;
    .right-label {
      margin-left: auto;
    }
    .right-label,
    .left-label {
      width: 30%;
      input {
        background-color: white;
        border-radius: ${quarterSpacing}px;
        border-color: ${gray5};
        height: ${tripleSpacing}px;
        font-size: 16px;
        &::placeholder {
          color: ${gray2};
        }
      }
    }
  }
`;
